import React, { useState, useRef } from "react";
import Moment from "moment";
import _ from "lodash";
import { extendMoment } from "moment-range";
import SimpleReactValidator from "simple-react-validator";
import Amount from "./Amount";

//<<< moment range plugin >>>
const moment = extendMoment(Moment);

const Units = (props) => {
	const [Unit, setUnit] = useState(1);

	const validator = useRef(new SimpleReactValidator());

	var _rangeToCheck,
		_range,
		_availableDates = [],
		amount;

	let { start, end, item, dates } = props;

	_rangeToCheck = (checkCB) => {
		let { start, end } = checkCB;
		const interval = [moment(start, "YYYY-MM-DD"), moment(end, "YYYY-MM-DD")];
		var _range = moment.range(interval);
		return _range;
	};

	const checkRange = (start, end) => {
		if (start !== "" && end !== "") {
			return {
				start: moment(start),
				end: moment(end),
				default: false
			};
		} else {
			return {
				start: moment().format("YYYY-MM-DD"),
				end: moment().format("YYYY-MM-DD"),
				default: true
			};
		}
	};

	_range = _rangeToCheck(checkRange(start, end));

	var itirateDates = (cb) => {
		var ranges = _.transform(
			dates,
			(memo, value) => {
				memo.push(...cb(value.date_from, value.date_to, value.units));
			},
			[]
		);

		return ranges;
	};

	_availableDates = itirateDates((s, e, u) => {
		var acc = [];
		if (moment(s).isValid() && moment(e).isValid()) {
			const range = moment.range(s, e);
			for (let days of _range.by("days")) {
				if (
					days.within(range, { excludeStart: false }, { excludeEnd: false })
				) {
					let dayIndex = _.indexOf(_availableDates, days.format("YYYY-MM-DD"));
					if (dayIndex === -1) {
						acc.push({
							date: days.format("YYYY-MM-DD"),
							unit: u,
							available: item.units - u
						});
					} else {
						_availableDates[dayIndex].units = JSON.stringify(
							parseInt(_availableDates[dayIndex].units) + parseInt(u)
						);
					}
				}
			}
		} else {
			for (let days of _range.by("days")) {
				if (s === "N/A" && e === "N/A") {
					let dayIndex = _.indexOf(_availableDates, days.format("YYYY-MM-DD"));
					if (dayIndex === -1) {
						acc.push({
							date: days.format("YYYY-MM-DD"),
							unit: u,
							available: item.units - u
						});
					} else {
						_availableDates[dayIndex].units = JSON.stringify(
							parseInt(_availableDates[dayIndex].units) + parseInt(u)
						);
					}
				}
			}
		}
		return acc;
	});

	var opt = () => {
		var cont = [];
		if (_availableDates.length === 0) {
			for (let i = 1; i <= item.units; i++) {
				cont.push(<option key={i}>{i}</option>);
			}
			return cont;
		} else if (_availableDates.length > 0) {
			var unitArr = _.transform(
				_availableDates,
				(memo, value) => {
					memo.push(value.available);
				},
				[]
			);

			var avail = _.min(unitArr);

			if (Unit > avail) setUnit(avail);

			//if (Unit <= 0) setUnit(1);

			for (let i = 1; i <= avail; i++) {
				cont.push(<option key={i}>{i}</option>);
			}

			return cont;
		}
	};

	if (start !== "" && end !== "") {
		amount = <Amount unit={Unit} start={start} end={end} item={item} />;
	}

	return (
		<>
			{amount}
			<div
				className="col-lg-4"
				style={{
					display: "inline",
					float: "left",
					marginTop: "5px",
					marginBottom: "5px"
				}}
			>
				<label htmlFor="units">Qty:</label>
			</div>
			<div
				className="col-lg-8"
				style={{
					display: "inline",
					float: "left",
					marginTop: "5px",
					marginBottom: "5px"
				}}
			>
				<select
					className="form-control"
					placeholder="please select units"
					id="units"
					name="units"
					value={Unit}
					onChange={(e) => {
						setUnit(e.target.value);
						validator.current.showMessageFor("units");
					}}
				>
					<option value="">Select Units</option>
					{opt()}
				</select>
				{validator.current.message("units", Unit, "required|numeric")}
			</div>
		</>
	);
};

export default Units;
